// extracted by mini-css-extract-plugin
export default {"content":"ResetPasswordModal_content__WKjHZ","modal":"ResetPasswordModal_modal__i9K8Y","title":"ResetPasswordModal_title__gdPUm"};